"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.setMainDivScrolled = exports.setIsLoading = exports.setContentModal = exports.setMessageModal = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const initialState = {
    isLoading: false,
    isDrawerOpen: false,
    drawerPageName: "login",
    messageModal: null,
    contentModal: null,
    mainDivScrolled: 0,
};
const slice = (0, toolkit_1.createSlice)({
    name: "main",
    initialState,
    reducers: {
        setIsLoading: (state, action) => {
            state.isLoading = action.payload;
        },
        setMessageModal: (state, action) => {
            var _a;
            state.messageModal = (_a = action === null || action === void 0 ? void 0 : action.payload) !== null && _a !== void 0 ? _a : null;
        },
        setContentModal: (state, action) => {
            var _a;
            state.contentModal = (_a = action === null || action === void 0 ? void 0 : action.payload) !== null && _a !== void 0 ? _a : null;
        },
        setMainDivScrolled: (state, action) => {
            state.mainDivScrolled = action.payload;
        },
    },
});
_a = slice.actions, exports.setMessageModal = _a.setMessageModal, exports.setContentModal = _a.setContentModal, exports.setIsLoading = _a.setIsLoading, exports.setMainDivScrolled = _a.setMainDivScrolled;
exports.default = slice.reducer;
